import React, { useState } from "react";
import { Row, Col, Form, Container, Button, Label } from "reactstrap";
import shallow from "zustand/shallow";
import useCurrentAccountStore from "./AccountStore";
import { PayOffMethod } from "../constants/Constants";
import InputElement, {
	CurrencyInput,
	IntegerInput,
	SelectorElement,
} from "features/forms/components/InputElement";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import { FormProvider } from "react-hook-form";
import InputWrapper from "features/forms/components/InputWrapper";
import AccountInsurance from "./AccountInsurance";
import ChildrenModal from "../components/modals/ChildrenModal";
import PastDueBreakdownCard from "./PastDueBreakdownCard";
import { getPayoffMethodLabels } from "./accountLabelUtils";

const AccountPayoff = () => {
	const { account, lease } = useCurrentAccountStore((state) => state, shallow);
	const labels = getPayoffMethodLabels(account.payoffMethod);
	const [openModal, setOpenModal] = useState(false);
	const toggleModal = () => {
		setOpenModal(!openModal);
	};

	const schema = yup.object().shape({});

	const methods = useForm({
		reValidateMode: "onBlur",
		resolver: yupResolver(schema),
	});
	const isLease = account.payoffMethod === 4;

	return (
		<>
			<FormProvider className="" {...methods}>
				<Container fluid style={{ maxWidth: "1800px" }}>
					{" "}
					{/* Limits the overall width */}
					<Form>
						<Row>
							{(isLease && (
								<Col xs="12" md="6" lg="2">
									{" "}
									{/* More compact width */}
									<InputWrapper
										formTitle="Payoff"
										inputComponents={[
											<SelectorElement
												{...methods}
												readOnly={true}
												disabled={true}
												name="payOffMethod"
												label="Payoff Method"
												value={account.payoffMethod}
												options={PayOffMethod}
												colSize="col-12"
											/>,
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.amtFinanced - account.principle}
												name="principle"
												label={labels.remainPrinciple}
												type="number"
												colSize="col-12"
											/>,
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.financeCharge - account.interest}
												name="interest"
												label={labels.interestAccrued}
												type="number"
												colSize="col-12"
											/>,
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.tax - account.taxPaid}
												name="tax"
												label="Remain Tax"
												type="number"
												colSize="col-12"
											/>,
											account.lateFeeDue > 0 && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.lateFeeDue}
													name="lateFeeDue"
													label="Remain LateFee"
													type="number"
													colSize="col-12"
												/>
											),
											account.debitCreditTotal - account.debitPaid > 0 && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.debitCreditTotal - account.debitPaid}
													name="remainAdj"
													label="Remain Adj"
													type="number"
													colSize="col-12"
												/>
											),
											account.pickupTotal - account.pickupPaid > 0 && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.pickupTotal - account.pickupPaid}
													name="remainpickup"
													label="Remain pickup"
													type="number"
													colSize="col-12"
												/>
											),
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.balance}
												name="leaseBalance"
												label="Lease Balance"
												type="number"
												colSize="col-12"
												style={{
													backgroundColor: "blue",
													color: "white",
													fontSize: "1.25rem",
													padding: "0.5rem",
												}}
											/>,

											<CurrencyInput
												disableValidation
												readOnly={true}
												value={lease.residualValue}
												name="residualValue"
												label="Residual Value"
												type="number"
												colSize="col-12"
											/>,

											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.payoff}
												name="payoff"
												label="Buyout Amount"
												type="number"
												colSize="col-12"
												labelClass="bigText"
												style={{
													backgroundColor: "green",
													color: "white",
													fontSize: "1.25rem",
													padding: "0.5rem",
												}}
											/>,
										]}
									/>
								</Col>
							)) || (
								<Col xs="12" md="6" lg="2">
									{" "}
									{/* More compact width */}
									<InputWrapper
										formTitle="Payoff"
										inputComponents={[
											<SelectorElement
												{...methods}
												readOnly={true}
												disabled={true}
												name="payOffMethod"
												label="Payoff Method"
												value={account.payoffMethod}
												options={PayOffMethod}
												colSize="col-12"
											/>,
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.amtFinanced - account.principle}
												name="principle"
												label={labels.remainPrinciple}
												type="number"
												colSize="col-12"
											/>,
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.unPaidInterest}
												name="interest"
												label={labels.interestAccrued}
												type="number"
												colSize="col-12"
											/>,
											account.isTaxDeferred && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.tax - account.taxPaid}
													name="tax"
													label="Remain Tax"
													type="number"
													colSize="col-12"
												/>
											),
											account.lateFeeDue > 0 && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.lateFeeDue}
													name="lateFeeDue"
													label="Remain LateFee"
													type="number"
													colSize="col-12"
												/>
											),
											account.debitCreditTotal - account.debitPaid > 0 && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.debitCreditTotal - account.debitPaid}
													name="remainAdj"
													label="Remain Adj"
													type="number"
													colSize="col-12"
												/>
											),
											account.pickupTotal - account.pickupPaid > 0 && (
												<CurrencyInput
													disableValidation
													readOnly={true}
													value={account.pickupTotal - account.pickupPaid}
													name="remainpickup"
													label="Remain pickup"
													type="number"
													colSize="col-12"
												/>
											),
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.payoff}
												name="payoff"
												label="Total Payoff"
												type="number"
												colSize="col-12"
												labelClass="bigText"
												style={{
													backgroundColor: "green",
													color: "white",
													fontSize: "1.25rem",
													padding: "0.5rem",
												}}
											/>,
										]}
									/>
								</Col>
							)}
							<Col xs="12" md="6" lg="2">
								{" "}
								{/* Adjust column size here */}
								<InputWrapper
									formTitle="Past Due"
									inputComponents={[
										<CurrencyInput
											disableValidation
											readOnly={true}
											value={account.principleDue}
											name="principle"
											label={labels.principalDue}
											type="number"
											colSize="col-12"
										/>,
										<CurrencyInput
											disableValidation
											readOnly={true}
											value={account.interestDue}
											name="interest"
											label={labels.interestDue}
											type="number"
											colSize="col-12"
										/>,
										<CurrencyInput
											disableValidation
											readOnly={true}
											value={
												account.interestDue + account.principleDue < 0
													? 0
													: account.interestDue + account.principleDue
											}
											name="loanDue"
											label={
												"Loan Due" +
												(account.interestDue + account.principleDue < 0
													? " (Balance < 0 => 0)"
													: "")
											}
											type="number"
											colSize="col-12"
											style={{
												backgroundColor: "lightblue",
												color: "black",
											}}
										/>,
										<CurrencyInput
											disableValidation
											readOnly={true}
											value={account.lateFeeDue}
											name="lateFeeDue"
											label="LateFee Due"
											type="number"
											colSize="col-12"
										/>,
										<CurrencyInput
											disableValidation
											readOnly={true}
											value={
												account.totalDebitCredit > 0
													? account.totalDebitCredit
													: 0
											}
											name="remainAdj"
											label="Adj Due"
											type="number"
											colSize="col-12"
										/>,
										account.pickupPastDue > 0 && (
											<CurrencyInput
												disableValidation
												readOnly={true}
												value={account.pickupPastDue}
												name="remainpickup"
												label="Pickup Due"
												type="number"
												colSize="col-12"
											/>
										),
										<Label className="bigText"> {"  "} Past Due</Label>,
										<Button
											key="pastDueAmtBtn"
											color="danger"
											className="w-100 text-left"
											style={{
												fontSize: "1.25rem",
												padding: ".40rem",
												margin: ".5rem",
											}}
											onClick={toggleModal}
										>
											{" "}
											{account.pastDueAmt?.toLocaleString("en-US", {
												style: "currency",
												currency: "USD",
											})}
										</Button>,
									]}
								/>
							</Col>
							<Col xs="12" md="6" lg="2">
								{" "}
								{/* Third column, adjust as needed */}
								<InputWrapper
									formTitle="Loan Dates"
									inputComponents={[
										<InputElement
											{...methods}
											readOnly={true}
											value={account.dateOfLastPmt}
											name="date"
											label="Last Paid Date"
											type="date"
											colSize="col-12"
										/>,
										<InputElement
											{...methods}
											readOnly={true}
											value={account.dateOfLastFullPmt}
											name="date"
											label="Last Full Paid Date"
											type="date"
											colSize="col-12"
										/>,
										<InputElement
											{...methods}
											readOnly={true}
											value={account.paidUntilDate}
											name="date"
											label="Paid Through Date"
											type="date"
											colSize="col-12"
										/>,

										<InputElement
											{...methods}
											readOnly={true}
											value={account.lastScheduledPmtDate}
											name="date"
											label="Previous Scheduled Date"
											type="date"
											colSize="col-12"
										/>,
										<InputElement
											{...methods}
											readOnly={true}
											value={account.nextDueDate}
											name="date"
											label={
												account.nextDueDate > account.finalDueDate
													? "Immediate Date"
													: "Next Scheduled Date"
											}
											type="date"
											colSize="col-12"
										/>,
										<IntegerInput
											{...methods}
											disableValidation
											readOnly={true}
											value={account.daysLate}
											name="daysLate"
											label="Days Late"
											type="number"
											colSize="col-12"
											labelClass="bigText"
											style={{
												backgroundColor: "red",
												color: "white",
												fontSize: "1.25rem",
												padding: "0.5rem",
											}}
										/>,
									]}
								/>
							</Col>
							<Col xs="12" md="6" lg="2">
								<InputWrapper
									formTitle="Pickup Dates "
									inputComponents={[
										<InputElement
											{...methods}
											readOnly={true}
											value={account.pickupLastPmtDate}
											name="date"
											label="Last Paid Date"
											type="date"
											colSize="col-12"
										/>,
										<InputElement
											{...methods}
											readOnly={true}
											value={account.paidThroughDate}
											name="date"
											label="Paid Through Date"
											type="date"
											colSize="col-12"
										/>,
										<InputElement
											{...methods}
											readOnly={true}
											value={account.pickupLastScheduledPmtDate}
											name="date"
											label="Previos Scheduled Date"
											type="date"
											colSize="col-12"
										/>,
										<InputElement
											{...methods}
											readOnly={true}
											value={account.pickupNextDueDate}
											name="date"
											label="Next Scheduled Date"
											type="date"
											colSize="col-12"
										/>,
										<IntegerInput
											{...methods}
											disableValidation
											readOnly={true}
											value={account.pickupDaysLate}
											name="date"
											label="Pickup Days Late"
											type="number"
											colSize="col-12"
											labelClass="bigText"
											style={{
												backgroundColor: "red", // Change the background color
												color: "white", // Change the font color
												fontSize: "20px",
											}}
										/>,
									]}
								/>
							</Col>
							<Col xs="12" md="6" lg="2">
								<AccountInsurance />
							</Col>
						</Row>
					</Form>
				</Container>
			</FormProvider>
			<ChildrenModal
				modal={openModal}
				toggle={toggleModal}
				modalTitle="Past-Due"
				size="lg"
			>
				{account.pastDueAmt > 0 && <PastDueBreakdownCard />}
			</ChildrenModal>
		</>
	);
};

export default AccountPayoff;
